import { FC, ReactNode, createContext, useContext, useState } from 'react';
import { useCookies } from 'react-cookie';

const useGlobalContextStore = () => {
  const [cookies, setCookie, removeCookie] = useCookies([
    'cart-item-count',
    'cart-item-price',
    'current-restaurant-id',
  ]);

  return {
    cookies,
    setCookie,
    removeCookie,
  };
};

type GlobalContextType = ReturnType<typeof useGlobalContextStore>;

const GlobalContext = createContext<GlobalContextType | null>(null);

type GlobalContextProviderProps = {
  children: ReactNode;
};

export const GlobalContextProvider: FC<GlobalContextProviderProps> = ({ children }) => {
  return <GlobalContext.Provider value={useGlobalContextStore()}>{children}</GlobalContext.Provider>;
};

export const useGlobalContext = () => {
  const globalCtx = useContext(GlobalContext);

  if (globalCtx === null) {
    throw new Error('GlobalContext is null');
  }

  return globalCtx;
};
